import * as React from "react";
import { UseInfiniteQueryResult } from "react-query";

import { ResponseProductsSearch } from "../../model";

import { usePlpDataSourceProductListQuery } from "../plp-data-source-product-list-provider";

interface ProductListDataConsumerInterface {
  data: UseInfiniteQueryResult<ResponseProductsSearch>["data"];
}

const defaultValue = {} as unknown as ProductListDataConsumerInterface;

const ProductListDataContext = React.createContext(defaultValue);

export const ProductListDataProvider: React.FunctionComponent = (props) => {
  const { data: productListQueryData, status } =
    usePlpDataSourceProductListQuery();

  const [data, setData] =
    React.useState<ProductListDataConsumerInterface["data"]>();

  React.useEffect(() => {
    const statusesWhichIndicateCompleteData: typeof status[] = [
      "success",
      "error",
    ];
    const doWeHaveCompleteDataToReplaceThePreviousDataState =
      statusesWhichIndicateCompleteData.includes(status);
    if (doWeHaveCompleteDataToReplaceThePreviousDataState) {
      setData(productListQueryData);
    }
  }, [productListQueryData, status]);

  const value: ProductListDataConsumerInterface = React.useMemo(
    () => ({
      data,
    }),
    [data]
  );
  return (
    <ProductListDataContext.Provider value={value}>
      {props.children || []}
    </ProductListDataContext.Provider>
  );
};

export const useProductListData = () => {
  const value = React.useContext(ProductListDataContext);
  if (value === defaultValue) {
    throw new Error(
      "useProductListData must be used within a ProductListDataProvider"
    );
  }
  return value;
};
